import { Chip } from '@mui/material'
import PropTypes from 'prop-types'

/**
 * The count beside a nav entry whose route declares `nav.useBadgeCount` (a hook returning
 * a number, cached by React Query). Nothing is shown at 0. Render it only for entries that
 * have the hook, so each instance always calls the same one.
 */
export default function NavBadgeCount({ useCount, label, sx }) {
    const count = useCount()
    if (!count) return null
    return (
        <Chip
            size="small"
            color="error"
            label={count > 99 ? '99+' : count}
            aria-label={`${count} ${label}`}
            data-testid="nav-badge-count"
            sx={{ ml: 1, height: 20, fontSize: '0.75rem', ...sx }}
        />
    )
}

NavBadgeCount.propTypes = {
    useCount: PropTypes.func.isRequired,
    label: PropTypes.string,
    sx: PropTypes.object
}

/** The badge for a nav entry, or nothing when its route has none. */
export function NavEntryBadge({ item, sx }) {
    return item.useBadgeCount ? (
        <NavBadgeCount
            useCount={item.useBadgeCount}
            label={item.badgeLabel ?? 'need attention'}
            sx={sx}
        />
    ) : null
}

NavEntryBadge.propTypes = {
    item: PropTypes.shape({
        useBadgeCount: PropTypes.func,
        badgeLabel: PropTypes.string
    }).isRequired,
    sx: PropTypes.object
}
